module.exports = __webpack_public_path__ + "static/oandg-ed647a2bba1c254548b673f27d9be2ca.jpg";